module.exports = __webpack_public_path__ + "KaTeX_Fraktur-Bold.4cc3b89f.woff";